import { Box } from "@mui/material";
import { closeSnackbar, enqueueSnackbar } from "notistack";

export const showUploadMessage = ({
  variant,
  message,
  description,
  persist = false,
  hideOnClick = false,
  ctaActionText,
  ctaActionFunction,
  secondaryCtaActionText,
  secondaryCtaActionFunction,
  showClose = false,
}: {
  variant: "uploading" | "uploadSuccess" | "uploadFailed" | "merging";
  message: string;
  description: string;
  persist?: boolean;
  hideOnClick?: boolean;
  ctaActionFunction?: VoidFunction;
  ctaActionText?: string;
  secondaryCtaActionFunction?: VoidFunction;
  secondaryCtaActionText?: string;
  showClose?: boolean;
}) => {
  const key = enqueueSnackbar(
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 1.25,
      }}
    >
      <div
        style={{
          fontWeight: 700,
          fontSize: "16px",
          lineHeight: "18px",
          color: "#0F1526",
        }}
      >
        {message}
      </div>
      <div
        style={{
          fontWeight: 400,
          fontSize: "14px",
          lineHeight: "16px",
          color: "#6F737D",
          maxWidth: "250px",
        }}
      >
        {description}
      </div>

      {(secondaryCtaActionText || ctaActionText) && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1.5,
            alignItems: "center",
          }}
        >
          {secondaryCtaActionText && secondaryCtaActionFunction && (
            <Box
              sx={(theme) => ({
                cursor: "pointer",
                color: theme.palette.text.secondary,
                fontSize: "14px",
                lineHeight: "16px",
              })}
              onClick={secondaryCtaActionFunction}
            >
              {secondaryCtaActionText}
            </Box>
          )}
          {ctaActionText && ctaActionFunction && (
            <Box
              sx={(theme) => ({
                cursor: "pointer",
                color: theme.palette.primary[100],
                fontSize: "14px",
                lineHeight: "16px",
              })}
              onClick={ctaActionFunction}
            >
              {ctaActionText}
            </Box>
          )}
        </Box>
      )}
    </Box>,
    {
      variant,
      persist,
      onClick: () => {
        if (hideOnClick) {
          closeSnackbar(key);
        }
      },
      description,
      showClose,
    }
  );
};
